module.exports = __webpack_public_path__ + "img/tou5.2a1fa8aa.jpg";